import Vue from 'vue';

const state = {};

const mutations = {};

const actions = {
  async fetchPublishingFundsPg({dispatch}) {
    const {data, status} = await Vue.axios.get ('/pg_editorial_funds');
    if (status != 200) {
      await dispatch ('generateSnackBarMessage', {
        message: 'Ocurrió un error al obtener los rubros',
        type: 'error',
      });
    }
    return {data, status};
  },
  async updatePublishingFundsPg ({dispatch}, publishingFundsPg) {
    const formData = new FormData ();
    formData.append ('title_cover_page', publishingFundsPg.title_cover_page);
    formData.append ('featured_book', publishingFundsPg.featured_book);
    if (publishingFundsPg.file_cover_page) {
      formData.append ('file_cover_page', publishingFundsPg.file_cover_page);
    }
    const {data, status} = await Vue.axios.post (
      `/pg_editorial_funds/${publishingFundsPg.id}`,
      formData
    );
    if (status != 200 && status != 201 && status != 204) {
      await dispatch ('createResponseMessage', {
        message: data.message ||
          'Ocurrió un error actualizando los datos del rubro',
        type: 'error',
      });
    } else {
      await dispatch ('generateSnackBarMessage', {
        message: data.message || 'Se guardó correctamente',
        type: 'success',
      });
    }
    return {data, status};
  },
};

export default {state, mutations, actions};
